<template>
  <section class="hack-feedback-section">
    <div class="hack-feedback-container">
      <h2 class="hack-section-title">Les témoignages des participants 2025</h2>

      <div class="hack-testimonials-grid">
        <div
          v-for="testimonial in testimonials"
          :key="testimonial.id"
          class="hack-testimonial-wrapper"
        >
          <div class="hack-card-shadow"></div>
          <div class="hack-testimonial-card">
            <span class="hack-quote-open">"</span>
            <p class="hack-testimonial-text">{{ testimonial.text }}</p>
            <span class="hack-quote-close">"</span>
            <div class="hack-testimonial-author">
              <span class="hack-author-name">{{ testimonial.name }},</span>
              <span class="hack-author-role">{{ testimonial.role }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "TestimonialsHackathon",
  data() {
    return {
      testimonials: [
        {
          id: 1,
          name: "Fifame",
          role: "Membre Equipe FINNEY",
          text: "Bitcoin Mastermind m'a ouvert les portes d'un réseau dynamique et m'a permis d'explorer de nouvelles perspectives. Une expérience qui dépasse toutes les attentes."
        },
        {
          id: 2,
          name: "Yam1st",
          role: "Membre Equipe NAKAMOTO",
          text: "Trois jours d'immersion totale dans l'écosystème Bitcoin, entouré de passionnés venus de toute l'Afrique de l'Ouest — c'est exactement le genre d'événement qui vous transforme."
        },
        {
          id: 3,
          name: "Ariane",
          role: "Membre Equipe G3N3SIS",
          text: "C'était bien. Une très belle expérience. J'ai pu développer mon réseau et apprendre beaucoup sur bitcoin"
        },
        {
          id: 4,
          name: "Geneviève",
          role: "Membre Equipe MINERS",
          text: "Merci à Bitcoin Mastermind pour cette expérience incroyablement enrichissante ! Une conférence à ne pas manquer pour les passionnés de Bitcoin."
        },
        {
          id: 5,
          name: "Sebastien",
          role: "Membre Equipe HODLERS",
          text: "Le hackaton de btc mastermind 2025 a été  pour moi l'occasion de decouvrir l'importance d'une collaboration en equipe ."
        },
        {
          id: 6,
          name: "Beni-Christ",
          role: "Membre Equipe G3N3SIS",
          text: "Le Bitcoin Mastermind Hackathon 2025 a été une expérience très enrichissante, alliant apprentissage technique et collaboration. L&apos;événement a rassemblé des profils variés, favorisant la création de solutions innovantes autour de Bitcoin."
        }
      ]
    };
  }
};
</script>

<style scoped>
.hack-feedback-section {
  width: 100%;
  max-width: 1728px;
  height: 810px;
  margin: 0 auto;
  background-color: #F6F1E9;
  display: flex;
  align-items: center;
}

.hack-feedback-container {
  max-width: 1728px;
  margin: 0 auto;
  padding: 0 64px;
  box-sizing: border-box;
  width: 100%;
}

.hack-section-title {
  font-family: 'DM Sans', sans-serif;
  font-size: 2rem;
  font-weight: 800;
  color: #0A1E4C;
  margin: 0 0 48px 0;
  letter-spacing: -0.01em;
}

.hack-testimonials-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0;
}

.hack-testimonial-wrapper {
  position: relative;
  width: 391px;
  height: 293px;
  margin: 20px;
  box-sizing: border-box;
  flex-shrink: 0;
}

.hack-card-shadow {
  position: absolute;
  width: 313px;
  height: 250px;
  top: 30px;
  left: 48px;
  border: 1px solid #000000;
  background: transparent;
  z-index: 1;
}

.hack-testimonial-card {
  position: relative;
  width: 343px;
  height: 263px;
  background-color: #FFFFFF;
  padding: 35px 40px 24px 40px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  z-index: 2;
}

.hack-quote-open {
  font-family: 'Brigends Expanded', Georgia, serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  color: #000000;
  align-self: flex-start;
  margin-bottom: 8px;
  display: block;
  width: 9px;
  height: 20px;
}

.hack-testimonial-text {
  font-family: 'DM Sans', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  color: #1F2937;
  margin: 0 0 4px 0;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.hack-quote-close {
  font-family: 'Brigends Expanded', Georgia, serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  color: #000000;
  align-self: flex-end;
  display: block;
  width: 9px;
  height: 20px;
  margin-top: 4px;
  transform: rotate(180deg) translateX(100%);
}

.hack-testimonial-author {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: 4px;
  margin-top: 4px;
}

.hack-author-name {
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #000000;
  white-space: nowrap;
}

.hack-author-role {
  font-family: 'DM Sans', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 12px;
  color: #9CA3AF;
  white-space: nowrap;
}

/* Responsive */
@media (max-width: 1200px) {
  .hack-testimonials-grid { grid-template-columns: repeat(2, 1fr); }
  .hack-feedback-section { height: auto; padding: 64px 0; }
}

@media (max-width: 768px) {
  .hack-feedback-container { padding: 0 24px; }
  .hack-testimonials-grid { grid-template-columns: 1fr; }
  .hack-testimonial-wrapper { margin: 0 auto 40px auto; width: 100%; max-width: 480px; }
  .hack-feedback-section { height: auto; padding: 60px 0; }
}
</style>
